/**
 * お気に入りボタンコンポーネント
 * ☆/★ トグルボタン
 */

import React, { useState, useEffect } from 'react';
import { isFavorite, addFavorite, removeFavorite, FavoriteSnapshot } from '../services/favoritesService';
import '../styles/FavoriteButton.css';

interface FavoriteButtonProps {
  snapshot: FavoriteSnapshot;
  onToggle?: (isFavorited: boolean) => void;
  size?: 'small' | 'medium' | 'large';
}

export const FavoriteButton: React.FC<FavoriteButtonProps> = ({
  snapshot,
  onToggle,
  size = 'medium'
}) => {
  const [favorited, setFavorited] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setFavorited(isFavorite(snapshot.symbol));
  }, [snapshot.symbol]);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // 親要素のクリックイベントを防止
    e.preventDefault();

    try {
      if (favorited) {
        // お気に入り解除
        removeFavorite(snapshot.symbol);
        setFavorited(false);
        onToggle?.(false);
      } else {
        // お気に入り登録
        addFavorite(snapshot);
        setFavorited(true);
        onToggle?.(true);
      }
      setError(null);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'お気に入り操作に失敗しました';
      console.error('❌ お気に入り操作エラー:', err);
      setError(errorMessage);

      // 3秒後にエラーメッセージを消す
      setTimeout(() => setError(null), 3000);
    }
  };

  return (
    <div className="favorite-button-container">
      <button
        className={`favorite-button favorite-button-${size} ${favorited ? 'favorited' : ''}`}
        onClick={handleClick}
        title={favorited ? 'お気に入り解除' : 'お気に入り登録'}
        aria-label={favorited ? 'お気に入り解除' : 'お気に入り登録'}
      >
        {favorited ? '★' : '☆'}
      </button>
      {error && (
        <div className="favorite-error-message">
          {error}
        </div>
      )}
    </div>
  );
};
